var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el"},[_c('pre',{class:("language language-" + _vm.language),domProps:{"innerHTML":_vm._s(_vm.getFormattedCode)}}),_c('div',{staticClass:"hidden"},[_c('login-panel',{staticClass:"absolute w-224 z-50"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }